<app-header></app-header>
<app-menu></app-menu>
<div
  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
  style="padding-top: 80px"
>
  <mat-tab-group
    mat-align-tabs="center"
    [selectedIndex]="indexTabs.value"
    (selectedIndexChange)="indexTabs.setValue($event)"
  >
    <mat-tab label="Inventory">
      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        style="margin-top: 20px; height: 500px"
      >
        <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
          applytabindexes
          [formGroup]="FormReceivingProducts"
        >
          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
          >
            <div
              class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 InputSty"
              style="margin-top: 1.4vh"
            >
              <mat-form-field appearance="fill" class="InputSty">
                <mat-label>Select customer</mat-label>
                <mat-select
                  formControlName="customer"
                  class="TabOnEnterReceiving"
                  tabindex="1"
                  (ngModelChange)="OnSelectProducts()"
                >
                  <mat-option
                    *ngFor="let item of PlaceOrderCustomer"
                    [value]="item.key"
                    >{{ item.value }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
            <div
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 InputSty"
              style="margin-top: 1.4vh"
            >
              <div class="row" *ngIf="viewEditar" style="margin-left: 30px">
                <input
                  matInput
                  style="border: 1px solid; margin-top: 1.2vh"
                  (keyup)="onKeyPlaceProducts($event.target.value)"
                  placeholder="search Item#"
                  class="form-control col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
                />
              </div>
            </div>
          </div>
          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
          >
            <div
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 InputSty"
              style="margin-top: 1.4vh"
            >
              <div class="row" *ngIf="viewEditar" style="margin-left: 30px">
                <mat-form-field
                  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
                >
                  <mat-label>select products</mat-label>
                  <mat-select
                    formControlName="PlaceProducts"
                    (ngModelChange)="onClickEditInventory()"
                    #ProdustSelect
                  >
                    <div *ngFor="let opt of PlaceProducts2">
                      <mat-option [value]="opt">
                        Item: {{ opt.ItemNumber }} Descripcion:
                        {{ opt.ItemDescription }} Location:
                        {{ opt.Location }} location Quantity:
                        {{ opt.locationQuantity }} Lot Number:
                        {{ opt.LotNumber }} available: {{ opt.available }}
                        {{ opt.locationID }}
                      </mat-option>
                    </div>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 InputSty"
              style="margin-top: 1.4vh"
            >
              <div class="row" style="margin-left: 30px" *ngIf="viewEditar2">
                <mat-form-field
                  class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 InputSty"
                  appearance="fill"
                >
                  <mat-label>Quantity</mat-label>
                  <input

                    matInput
                    type="number"
                    formControlName="quantity"

                  />
                        </mat-form-field>
                        <div
                        class="
                        col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6
                          "
                        style="text-align: center"
                      >
                        <button
                          style="width: 180px"
                          mat-raised-button
                          color="primary"
                          class="
                              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                            "
                          (click)="onEditInventoryModule_Update()"
                          type="button"
                        >
                       Save
                        </button>
                    
                      </div>      

              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
<ngx-spinner
  bdColor="rgba(0,0,0,0.07)"
  size="medium"
  color="#2879ff"
  type="square-jelly-box"
  [fullScreen]="true"
>
</ngx-spinner>
